<template>
  <div :class="['header-wrap', { sticky: isSticky }]">
    <!-- Top Header -->
    <div class="header-top" :class="{ open: open }">
      <button type="button" class="close-sidebar" @click="open = !open">
        <i class="ri-close-fill"></i>
      </button>
      <div class="container">
        <div class="row align-items-center">
          <div class="col-lg-8 col-md-9">
            <div class="header-top-left">
              <ul class="contact-info list-style">
                <li>
                  <i class="flaticon-call"></i>
                  <a href="tel:0160601717">(+229) 01 61 39 47 47</a>
                </li>
                <li>
                  <i class="flaticon-email-1"></i>
                  <a href="mailto:eitp@yahoo.com">eitp@yahoo.com</a>
                </li>
                <li>
                  <i class="flaticon-pin"></i>
                  <p>Cotonou, Gbégamey, à côté du petit portail Aupiais</p>
                </li>
              </ul>
            </div>
          </div>

          <div class="col-lg-4 col-md-3">
            <div class="header-top-right">
              <ul class="header-top-menu list-style">

                <li><router-link to="/faq">FAQ</router-link></li>
                <li><router-link to="/contact">Contact</router-link></li>
                
                <li class="nav-item">
                  <a a href="javascript:void(0);" class="nav-link">
                    {{ totalVisiteurs }} Visiteurs</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- End Top Header -->

    <!-- Navbar -->
    <div class="header-bottom">
      <div class="container">
        <nav class="navbar navbar-expand-md navbar-light">
          <div class="logo-wrapper">
      <router-link class="navbar-brand" to="/">
        <img
          class="logo-light"
          src="../../assets/images/logo-eitp.png"
          style="height: 70px !important"
          alt="logo"
        />
        <img
          class="logo-dark"
          src="../../assets/images/logo-eitp.png"
          alt="logo"
          style="height: 70px !important"
        />
      </router-link>

      <p class="devise">
        Et lux in tenebris lucet : Africæ munus
      </p>
</div>

          <div class="collapse navbar-collapse" :class="{ show: active }">
            <ul class="navbar-nav ms-auto">
              <!-- ANCIEN MENU "QUI SOMMES-NOUS" - Commenté
              <li class="nav-item has-dropdown">
                <a href="#" class="nav-link">
                  Qui sommes-nous?
                  <i class="ri-arrow-down-s-line"></i>
                </a>
                <ul class="dropdown-menu">
                  <li class="nav-item">
                    <router-link to="/mission" class="nav-link">MISSION-HISTORIQUE-DECRET D'ERECTION</router-link>
                  </li>
                  <li class="nav-item">
                    <router-link to="/organisation" class="nav-link">ORGANISATION</router-link>
                  </li>
                  <li class="nav-item">
                    <router-link to="/statut" class="nav-link">STATUTS ET REGLEMENTS</router-link>
                  </li>
                  <li class="nav-item">
                    <router-link to="/disciple" class="nav-link">DISCIPLES D'EMMAUS</router-link>
                  </li>
                  <li class="nav-item">
                    <router-link to="/activite" class="nav-link">NOS ACTIVITES</router-link>
                  </li>
                  <li class="nav-item">
                    <router-link to="/contact" class="nav-link">CONTACTS, ADRESSE & HORAIRES</router-link>
                  </li>
                </ul>
              </li>
              -->

              <!-- NOUVEAU MENU EITP -->
              <li class="nav-item has-dropdown">
                <a href="#" class="nav-link">
                  NOTRE ECOLE
                  <i class="ri-arrow-down-s-line"></i>
                </a>
                <ul class="dropdown-menu">
                  <li class="nav-item">
                    <router-link to="/quisommesnouss" class="nav-link non-clickable disabled-link">QUI-SOMMES-NOUS?</router-link>
                    <ul class="dropdown-menu">
                      <li class="nav-item">
                        <router-link to="/quisommesnouss" class="nav-link">Historique</router-link>
                      </li>
                      <li class="nav-item">
                        <router-link to="/missionEitp" class="nav-link">Mission</router-link>
                      </li>
                      <li class="nav-item">
                        <router-link to="/decret" class="nav-link">Décret</router-link>
                      </li>
                      
                    </ul>
                  </li>
                  <li class="nav-item">
                    <router-link to="/responsables" class="nav-link">RESPONSABLES INSTITUTIONNELS</router-link>
                    <!-- <ul class="dropdown-menu">
                      <li class="nav-item">
                        <router-link to="/" class="nav-link">CHANCELIER</router-link>
                      </li>
                      <li class="nav-item">
                        <router-link to="/" class="nav-link">DIRECTEUR</router-link>
                      </li>
                      <li class="nav-item">
                        <router-link to="/" class="nav-link">FORMATEURS</router-link>
                      </li>
                      

                    </ul> -->
                  </li>
                  <li class="nav-item">
                    <router-link to="/normeadministrative" class="nav-link">NORMES ADMINISTRATIVES</router-link>
                  </li>
                  <li class="nav-item">
                    <router-link to="/secretariat" class="nav-link">SECRETARIAT</router-link>
                   
                  </li>
                  <!-- <li class="nav-item">
                    <router-link to="/professeurs" class="nav-link">PROFESSEURS</router-link>
                  </li> -->
                  <li class="nav-item">
                    <router-link to="/discipleEmmaus" class="nav-link">LES ALUMNIS</router-link>
                    <ul class="dropdown-menu">
                      <li class="nav-item">
                        <router-link to="/discipleEmmaus" class="nav-link">Disciples Emmaüs</router-link>
                      </li>
                      <li class="nav-item">
                        <router-link to="/habitues" class="nav-link">Habitués</router-link>
                      </li>
                      <li class="nav-item">
                        <router-link to="/auditeurs" class="nav-link">Auditeurs</router-link>
                      </li>
                    </ul>
                  </li>
                   <li class="nav-item">
                    <router-link to="/" class="nav-link non-clickable disabled-link">LES ALUMNIS EN MISSION</router-link>
                     <ul class="dropdown-menu">
                      <li class="nav-item">
                        <router-link to="/tuteurs" class="nav-link">Tutorat</router-link>
                      </li>
                      <li class="nav-item">
                        <router-link to="/animateurss" class="nav-link">Les animateurs</router-link>
                      </li>
                    </ul>
                  </li>
                   <!-- <li class="nav-item">
                    <router-link to="/animateurss" class="nav-link">LES ANIMATEURS</router-link>
                  </li> -->
                  <li class="nav-item">
                    <router-link to="/equipes" class="nav-link non-clickable disabled-link">NOS EQUIPES</router-link>
                    <ul class="dropdown-menu">
                      <li class="nav-item">
                        <router-link to="/liturgie" class="nav-link">Liturgie</router-link>
                      </li>
                      <li class="nav-item">
                        <router-link to="/chorale" class="nav-link">Chorale</router-link>
                      </li>
                      <li class="nav-item">
                        <router-link to="/organisations" class="nav-link">Organisation</router-link>
                      </li>
                      <li class="nav-item">
                        <router-link to="/revue" class="nav-link">Revue de l'école</router-link>
                      </li>
                    </ul>
                  </li>
                   <li class="nav-item">
                    <router-link to="/mouvements" class="nav-link non-clickable disabled-link">NOS MOUVEMENTS</router-link>
                    <ul class="dropdown-menu">
                      <li class="nav-item">
                        <router-link to="/amis" class="nav-link">Amis</router-link>
                      </li>
                      <li class="nav-item">
                        <router-link to="/amiSeminaire" class="nav-link">Amis des séminaires</router-link>
                      </li>
                      <li class="nav-item">
                        <router-link to="/petiteVoie" class="nav-link">Petite voie</router-link>
                      </li>
                    </ul>
                  </li>
                  <!-- <li class="nav-item">
                    <router-link to="/" class="nav-link">MEDIATHEQUE</router-link>
                  </li>
                  <li class="nav-item">
                    <router-link to="/" class="nav-link">VIDEOS</router-link>
                  </li>
                  <li class="nav-item">
                    <router-link to="/" class="nav-link">PHOTOS</router-link>
                  </li> -->
                  <!--<li class="nav-item">
                    <router-link to="/eitp/eitp-en-mission" class="nav-link">EITP EN MISSION</router-link>
                  </li>
                  <li class="nav-item">
                    <router-link to="/eitp/chronoskairos" class="nav-link">CHRONOS ET RATIOS</router-link>
                  </li>
                  <li class="nav-item">
                    <router-link to="/eitp/notrerevue" class="nav-link">NOTRE REVUE</router-link>
                  </li>-->
                </ul>
              </li>

              <!-- MENU FORMATION  -->
              <li class="nav-item has-dropdown">
                <a href="#" class="nav-link">
                  NOS COURS
                  <i class="ri-arrow-down-s-line"></i>
                </a>
                <ul class="dropdown-menu">
                  <li class="nav-item">
                    <router-link to="/formations/nosformations" class="nav-link">A PROPOS DE NOS
                      PARCOURS</router-link>

                    <ul class="dropdown-menu">
                      <li class="nav-item">
                        <router-link to="/parcoursDisciples" class="nav-link">Parcours Disciples d’Emmaüs</router-link>
                      </li>
                      <li class="nav-item">
                        <router-link to="/parcourSup" class="nav-link">Parcours Disciples d’Emmaüs Sup</router-link>
                      </li>
                      <li class="nav-item">
                        <router-link to="/parcourOmega" class="nav-link">Parcours OMEGA </router-link>
                      </li>
                      <li class="nav-item">
                        <router-link to="/parcourUnite" class="nav-link">La formation par unités</router-link>
                      </li>
                      <li class="nav-item">
                        <router-link to="/cafePage" class="nav-link">Les Cafés Théologiques</router-link>
                      </li>

                    </ul>
                  </li>
                  <li class="nav-item">
                    <router-link to="/" class="nav-link non-clickable disabled-link">COMMUNAUTES DES PARCOURS</router-link>
                    <ul class="dropdown-menu">
                      <li class="nav-item">
                        <router-link to="/apprenants" class="nav-link">Apprenants</router-link>
                      </li>
                      <li class="nav-item">
                        <router-link to="/professeurs" class="nav-link">Enseignants</router-link>
                      </li>
                      
                    </ul>
                  </li>
                  <!-- <li class="nav-item">
                    <router-link to="#" class="nav-link">APPRENANTS</router-link>
                  </li>
                   <li class="nav-item">
                    <router-link to="#" class="nav-link">LA FORMATION PAR UNITES</router-link>
                  </li>
                   <li class="nav-item">
                    <router-link to="#" class="nav-link">LES CAFES THEOLOGIQUES</router-link>
                  </li>
                   <li class="nav-item">
                    <router-link to="#" class="nav-link">AUTRES FORMATIONS</router-link>
                  </li>
                   -->
                  <!-- ANCIEN CONTENU DU MENU FORMATION - Commenté pour réutilisation
                  <li class="nav-item has-dropdown">
                    <a href="#" class="nav-link">
                      S'INSCRIRE
                      <i class="ri-arrow-down-s-line"></i>
                    </a>
                    <ul class="dropdown-menu">
                      <li class="nav-item">
                        <a href="#" class="nav-link">
                          FORMULAIRE D'INSCRIPTION: PARCOURS OMEGA
                        </a>
                      </li>
                      <li class="nav-item">
                        <router-link to="/inscription" class="nav-link">FORMULAIRE D'INSCRIPTION</router-link>
                      </li>
                      <li class="nav-item">
                        <router-link to="/frais" class="nav-link">FRAIS ACADEMIQUES</router-link>
                      </li>
                      <li class="nav-item">
                        <router-link to="/apropo" class="nav-link">A PROPOS D'UNE ACTIVITE OU UNE
                          AUTRE</router-link>
                      </li>
                      <li class="nav-item">
                        <router-link to="/examen" class="nav-link">S'INSCRIRE A UN EXAMEN</router-link>
                      </li>
                      <li class="nav-item">
                        <router-link to="/ratrappage" class="nav-link">S'INSCRIRE A UN RATRAPPAGE</router-link>
                      </li>
                    </ul>
                  </li>
                  <li class="nav-item">
                    <a href="#" class="nav-link">
                      COURS
                    </a>
                  </li>
                  <li class="nav-item">
                    <router-link to="/cours" class="nav-link">COURS ET SEMINAIRES (1ERE ANNEE)</router-link>
                  </li>
                  <li class="nav-item">
                    <router-link to="/seminaire" class="nav-link">COURS ET SEMINAIRES (2EME ANNEE)</router-link>
                  </li>
                  <li class="nav-item">
                    <router-link to="/formateur" class="nav-link">LES FORMATEURS</router-link>
                  </li>
                  <li class="nav-item">
                    <router-link to="/laboratoire" class="nav-link">LES LABORATOIRES</router-link>
                  </li>
                  <li class="nav-item">
                    <router-link to="/formation" class="nav-link">FORMATIONS DIVERSES</router-link>
                  </li>
                  <li class="nav-item">
                    <router-link to="/annuaire" class="nav-link">ANNUAIRES ACADEMIQUES</router-link>
                  </li>
                  -->
                </ul>
              </li>

              <li class="nav-item has-dropdown">
                <a href="#" class="nav-link">
                  NOS PARCOURS
                  <i class="ri-arrow-down-s-line"></i>
                </a>
                
                <ul class="dropdown-menu">
                  <li class="nav-item">
                    <router-link to="/" class="nav-link">VIE SPIRITUELLE</router-link>
                    <ul class="dropdown-menu">
                        <li class="nav-item">
                            <router-link to="/spiritual" class="nav-link">Parcours spirituels</router-link>
                          </li>
                          <li class="nav-item">
                            <router-link to="/retraites" class="nav-link">Retraites de fin d'initiation</router-link>
                          </li>
                          <li class="nav-item">
                            <router-link to="/pelerinages" class="nav-link">Pèlerinage</router-link>
                          </li>
                          <li class="nav-item">
                            <router-link to="/conferencess" class="nav-link">Conférences d'avent et de carême</router-link>
                          </li>
                          <li class="nav-item">
                            <router-link to="/recollections" class="nav-link">Retraites et recollections</router-link>
                          </li>
                          
                    </ul>
                  </li>
                  <li class="nav-item">
                    <router-link to="/paraacademiques" class="nav-link">VIE PARAACADEMIQUE</router-link>
                    <ul class="dropdown-menu">
                      <li class="nav-item">
                        <router-link to="/diesAcademicus" class="nav-link">Dies academicus</router-link>
                      </li>
                      <li class="nav-item">
                        <router-link to="/soiretheologique" class="nav-link">Soirées Théologiques</router-link>
                      </li>
                      <li class="nav-item">
                        <router-link to="/ceremonie" class="nav-link">Cérémonies Académiques</router-link>
                      </li>
                      <li class="nav-item">
                        <router-link to="/colloques" class="nav-link">Colloques</router-link>
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>
              <!-- ANCIEN MENU RECHERCHES - Commenté
              <li class="nav-item has-dropdown">
                <a href="#" class="nav-link">
                  RECHERCHES
                  <i class="ri-arrow-down-s-line"></i>
                </a>
                <ul class="dropdown-menu">
                  <li class="nav-item has-dropdown">
                    <a href="#" class="nav-link">
                      NOTRE REVUE
                      <i class="ri-arrow-down-s-line"></i>
                    </a>
                    <ul class="dropdown-menu">
                      <li class="nav-item">
                        <a href="#" class="nav-link">
                          PRESENTATION
                        </a>
                      </li>
                      <li class="nav-item">
                        <router-link to="/parution" class="nav-link"> DERNIERE PARUTION</router-link>
                      </li>
                    </ul>
                  </li>
                  <li class="nav-item">
                        <router-link to="/matinees" class="nav-link"> MATINEES / SOIREES THEOLOGIQUES </router-link>
                      </li>
                  <li class="nav-item">
                    <router-link to="/colloque" class="nav-link">COLLOQUES</router-link>
                  </li>
                  <li class="nav-item">
                    <router-link to="/conference" class="nav-link">CONFERENCES - DIES ACADEMICUS</router-link>
                  </li>
                  <li class="nav-item">
                    <router-link to="/publication" class="nav-link">PUBLICATIONS</router-link>
                  </li>
                  <li class="nav-item">
                    <router-link to="/bibliotheque" class="nav-link">BIBLIOTHEQUE</router-link>
                  </li>
                  <li class="nav-item">
                    <router-link to="/librairie" class="nav-link">LIBRAIRIE</router-link>
                  </li>
                  <li class="nav-item">
                    <router-link to="/revu" class="nav-link">REVU DE L'ECOLE
                      (CULTURE-FOI-RAISON)</router-link>
                  </li>
                </ul>
              </li>
              -->

              <!-- ANCIEN MENU "CHRONOS ET KAIROS" - Commenté
              <li class="nav-item has-dropdown">
                <a href="#" class="nav-link">
                  CHRONOS ET KAIROS
                  <i class="ri-arrow-down-s-line"></i>
                </a>
                <ul class="dropdown-menu">
                  <li class="nav-item">
                    <a href="#" class="nav-link">
                      FRATRES ABITARE IN UNUM
                    </a>
                  </li>
                  <li class="nav-item">
                    <router-link to="/fides" class="nav-link">FIDES ET RATIO</router-link>
                  </li>
                  <li class="nav-item">
                    <router-link to="/spiritu" class="nav-link">IN SPIRITU ET VERITATE</router-link>
                  </li>
                  <li class="nav-item">
                    <router-link to="/lux" class="nav-link">LUX MUNDI</router-link>
                  </li>
                </ul>
              </li>
              -->

              <!-- ANCIEN MENU "L'EITP EN MISSION" - Commenté
              <li class="nav-item has-dropdown">
                <a href="#" class="nav-link">
                  L'EITP EN MISSION
                  <i class="ri-arrow-down-s-line"></i>
                </a>
                <ul class="dropdown-menu">
                  <li class="nav-item">
                    <router-link to="/code-engagement" class="nav-link">  CODE D'ENGAGEMENT</router-link>
                  </li>
                  <li class="nav-item">
                    <router-link to="/benevoles" class="nav-link"> BENEVOLES</router-link>
                  </li>
                  <li class="nav-item">
                    <router-link to="/soutien" class="nav-link">SOUTIENS</router-link>
                  </li>
                  <li class="nav-item">
                    <router-link to="/animateur" class="nav-link">ANIMATEURS</router-link>
                  </li>
                  <li class="nav-item">
                    <router-link to="/axe" class="nav-link">AXE ANIMATION</router-link>
                  </li>
                  <li class="nav-item">
                    <router-link to="/niveau" class="nav-link">NIVEAU PERSONNEL</router-link>
                  </li>
                </ul>
              </li>
              -->




              <!-- MENU "MÉDIATHÈQUE"  -->
              <!-- <li class="nav-item has-dropdown">
                <a href="#" class="nav-link">
                  MÉDIATHÈQUE
                  <i class="ri-arrow-down-s-line"></i>
                </a>
                <ul class="dropdown-menu">
                  <li class="nav-item">
                    <router-link to="/mediatheque/formateurs" class="nav-link">NOS FORMATEURS</router-link>
                  </li>
                  <li class="nav-item">
                    <router-link to="/mediatheque/nosdisciples" class="nav-link"> NOS DISCIPLES</router-link>
                  </li>
                  <li class="nav-item">
                    <router-link to="/mediatheque/activites" class="nav-link"> NOS ACTIVITES</router-link>
                  </li>
                  <li class="nav-item">
                    <router-link to="/mediatheque/nosvideos" class="nav-link">NOS VIDEOS</router-link>
                  </li>
                  
                </ul>
              </li>-->
              <!--   <li class="nav-item">
                    <router-link to="/contact" class="nav-link">CONTACTS</router-link>
              </li>-->
               <li class="nav-item has-dropdown">
                <a href="#" class="nav-link">
                  RECHERCHES
                  <i class="ri-arrow-down-s-line"></i>
                </a>
                <ul class="dropdown-menu">
                  <li class="nav-item">
                    <router-link to="/revueculture" class="nav-link">REVUE</router-link>
                  </li>
                  <li class="nav-item">
                    <router-link to="/laboratoires" class="nav-link">LABORATOIRE</router-link>       
                  </li>
                  <li class="nav-item">
                    <router-link to="/textes" class="nav-link">NOS TEXTES</router-link>  
                  </li>
                   
                  <li class="nav-item">
                    <router-link to="/bibliothequess" class="nav-link">BIBLIOTHEQUE</router-link>
                  </li>
                  <li class="nav-item">
                    <router-link to="/publications" class="nav-link">PUBLICATIONS DES ENSEIGNANTS</router-link>
                  </li>
                  <li class="nav-item">
                    <router-link to="/memoireApprenant" class="nav-link">MEMOIRES DES APPRENANTS</router-link>
                  </li>
                </ul>
              </li>

              <!-- MENU RECHERCHE -->
              <!-- <li class="nav-item">
                <router-link to="/eitp/recherches" class="nav-link">RECHERCHES</router-link>
              </li>-->
              <!-- NOUVEAU MENU "ACTUALITÉS" -->
              <li class="nav-item">
                <router-link to="/" class="nav-link">GALERIE</router-link>
                   <ul class="dropdown-menu">
                  <li class="nav-item">
                    <router-link to="/phototheque" class="nav-link">PHOTOTHEQUE</router-link>
                  </li>
                  <li class="nav-item">
                    <router-link to="/videotheque" class="nav-link">VIDEOTHEQUE</router-link>       
                  </li>
                </ul>
              </li>

              <!-- NOUVEAU MENU "EITP SOLIDARITÉ"  -->
              <li class="nav-item">
                <a href="https://eitp.solidarite.nostests.com/" class="nav-link" target="_blank">
                  EITP SOLIDARITÉ
                </a>
              </li>

              <div class="header-btn"> 
              <a href="https://eitp.admin.nostests.com/" 
                class="btn btn-sm style1 fs16" 
                style="margin-top: 10px; background-color: #F39C12; border-color: #D68910;" 
                target="_blank">
                <b>FORMATION EN LIGNE</b>
              </a>
            </div>

              <!-- BOUTON "SE CONNECTER" -->
              <!--   <div class="header-btn">
                <a 
                  href="https://eitp.admin.nostests.com/" 
                  class="btn btn-sm style1 fs16" 
                  style="margin-top: 10px;" 
                  target="_blank"
                >
                  <b>Se connecter</b>
                </a>
              </div>-->

            </ul>
          </div>
          <div class="mobile-bar-wrap">
            <div class="mobile-sidebar" @click="open = !open" :aria-pressed="open ? 'true' : 'false'"
              v-bind:class="{ open: button_open_state }" v-on:click="button_open_state = !button_open_state">
              <i class="ri-menu-4-line"></i>
            </div>
            <button class="searchbtn" type="button" @click="search = !search" :aria-pressed="search ? 'true' : 'false'"
              v-bind:class="{ search: button_search_state }" v-on:click="button_search_state = !button_search_state">
              <i class="flaticon-search"></i>
            </button>
            <div class="navbar-toggler mobile-menu xl-none" @click="active = !active"
              :aria-pressed="active ? 'true' : 'false'" v-bind:class="{ active: button_active_state }"
              v-on:click="button_active_state = !button_active_state">
              <a href="javascript:void(0);">
                <i class="ri-menu-line"></i>
                <i class="ri-close-line"></i>
              </a>
            </div>
          </div>
        </nav>
      </div>
      <!-- Search Modal -->
      <div class="search-area" :class="{ search: search }">
        <div class="container">
          <form @submit.prevent>
            <div class="form-group">
              <input type="search" placeholder="Search Here" autofocus />
            </div>
          </form>
          <button type="button" class="close-searchbox" @click="search = !search">
            <i class="ri-close-line"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import ApiService from "@/services/ApiService";
import { defineComponent, onMounted, ref } from "vue";

export default defineComponent({
  name: "NavBar",
  setup() {
    const isSticky = ref(false);
    const active = ref(false);
    const button_active_state = ref(false);
    const search = ref(false);
    const button_search_state = ref(false);
    const open = ref(false);
    const button_open_state = ref(false);
    const totalVisiteurs = ref(0);

    onMounted(() => {
      window.addEventListener("scroll", () => {
        let scrollPos = window.scrollY;
        if (scrollPos >= 100) {
          isSticky.value = true;
        } else {
          isSticky.value = false;
        }
      });
      getNbVisiteurs();
    });

    const getNbVisiteurs = () => {
      return ApiService.get("/visiteurs")
        .then(({ data }) => {
          console.log("TRTRTRRRTRTRTYUIYTYIUO ===> ", data);
          totalVisiteurs.value = data.data.data;
        })
        .catch(({ response }) => {
          //error(response.data.message)
        });
    };

    return {
      isSticky,
      active,
      button_active_state,
      search,
      button_search_state,
      open,
      button_open_state,
      totalVisiteurs,
    };
  },
});
</script>
<style>
.disabled-link {
  pointer-events: none;  
  cursor: default;       
  opacity: 0.6;          
}

.logo-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.devise {
  font-size: 10px;
  font-style: italic;
  margin-top: 4px;
  color: #0b1b3f;
}


</style>